import React from 'react';
import { FiBarChart2, FiChevronRight } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import './LearningReportButton.scss';

const LearningReportButton = ({ classCode }) => {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      className="digital-lms-report-button"
      onClick={() => navigate('/lms/report', { state: { classCode } })}
    >
      <span className="digital-lms-report-button__icon">
        <FiBarChart2 aria-hidden="true" />
      </span>
      <span className="digital-lms-report-button__copy">
        <strong>학습 리포트</strong>
        <small>일·주·월 학습 현황 보기</small>
      </span>
      <span className="digital-lms-report-button__arrow">
        <FiChevronRight aria-hidden="true" />
      </span>
    </button>
  );
};

export default LearningReportButton;
